import { ReactNode } from 'react'
import { DialogContent, SxProps } from '@mui/material'
import MUIDialog from '@mui/material/Dialog'
import { Breakpoint } from '@mui/system'
import DialogActions from 'src/components/shared/ui/DialogActions'
import { theme } from 'src/providers/ThemeProvider'
import DialogTitle from './DialogTitle'

export const styles = {
  root: {
    '& .MuiDialog-container .MuiDialog-paper': {
      borderRadius: '8px',
      border: `1px solid ${theme.colors.main200}`,
      boxShadow: `0px 2px 9px 0px rgba(113, 113, 113, 0.25)`,

      '& .MuiDialogContent-root': {
        padding: theme.spacing(1.5, 3, 3, 3)
      },

      '& .MuiDialogTitle-root': {},

      '& .MuiDialogActions-root': {
        padding: '20px 20px 15px'

        // '& .MuiButton-root.Mui-disabled': {
        //   borderColor: theme.colors.blue04,
        //   color: theme.colors.blue04
        // }
      }
    }
  }
}

interface Props {
  title: ReactNode
  children: ReactNode
  close: () => void
  isOpen?: boolean
  buttons?: ReactNode
  dialogContentStyle?: SxProps
  closeClickingOutsideDialogAndEscapeKey?: boolean
  maxWidth?: false | Breakpoint
  titleMode?: 'default' | 'withBg'
}

export default function LexnetDialog({
  title,
  children,
  close,
  isOpen = false,
  maxWidth = 'md',
  dialogContentStyle = {} as SxProps,
  buttons,
  titleMode = 'default',
  closeClickingOutsideDialogAndEscapeKey = false
}: Props): JSX.Element {
  return (
    <MUIDialog
      onClose={closeClickingOutsideDialogAndEscapeKey ? close : undefined}
      open={isOpen}
      fullWidth
      maxWidth={maxWidth}
      fullScreen={false}
      sx={styles.root}
    >
      <DialogTitle mode={titleMode}>{title}</DialogTitle>
      <DialogContent sx={dialogContentStyle}>{children}</DialogContent>
      {buttons && <DialogActions>{buttons}</DialogActions>}
    </MUIDialog>
  )
}
